export class PitrRestoreVaultWindows {
    'vaultId';
    'ranges';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "ranges",
            "baseName": "ranges",
            "type": "Array<PitrRestoreWindow>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PitrRestoreVaultWindows.attributeTypeMap;
    }
    constructor() {
    }
}
